import React from 'react';
import Header, { IProps as HeaderIProps } from '@elements/header';
import Footer from '@elements/footer';

interface IProps extends HeaderIProps {
  children: HTMLDivElement | React.ReactNode;
}

export default function HeaderAndFooter(props: IProps) {
  const { children, isStickyHeader } = props;
  return (
    <>
      <Header isStickyHeader={isStickyHeader} />
      <div style={{ minHeight: 'calc(100vh - 80px - 243px)' }}>{children}</div>
      <Footer />
    </>
  );
}
